import SEO from '../components/SEO'
import ScrollReveal from '../components/ScrollReveal'
import CTASection from '../components/CTASection'
import './Services.css'
import '../styles/shared-hero.css'

const services = [
  {
    title: 'Fractional CTO',
    description: 'Ongoing technology leadership on a part-time basis. Ideal for growing companies that need executive-level guidance without the full-time commitment.',
    features: ['Strategic roadmap development', 'Architecture oversight', 'Team building and hiring', 'Vendor management', 'Board and investor reporting'],
  },
  {
    title: 'Interim CTO',
    description: 'Full-time leadership during transitions, whether between permanent hires, during scale-up phases, or through periods of crisis.',
    features: ['Immediate leadership coverage', 'Crisis stabilisation', 'Process establishment', 'Team restructuring', 'Handover to permanent hire'],
  },
  {
    title: 'Technology Assessment',
    description: 'Comprehensive evaluation of your current technology state—systems, processes, team capabilities, and strategic alignment.',
    features: ['Architecture review', 'Technical debt analysis', 'Security assessment', 'Team capability evaluation', 'Process maturity scoring'],
  },
  {
    title: 'Digital Transformation',
    description: 'Strategic guidance for modernising legacy systems, adopting cloud infrastructure, and digitising operations.',
    features: ['Legacy system evaluation', 'Cloud migration strategy', 'Process automation', 'Integration planning', 'Change management'],
  },
]

const engagementModels = [
  {
    title: 'Advisory Retainer',
    description: 'Regular scheduled access for strategic guidance, typically 1-2 days per week.',
  },
  {
    title: 'Project-Based',
    description: 'Defined scope with clear deliverables, such as architecture reviews or roadmap development.',
  },
  {
    title: 'Interim Leadership',
    description: 'Full-time engagement for defined periods, typically 3-12 months.',
  },
]

function Services() {
  return (
    <>
      <SEO 
        title="Services" 
        description="Explore our fractional CTO services, from ongoing technology leadership to project-based assessments and digital transformation."
        path="/services"
      />
      
      {/* Hero Section */}
      <section className="services-hero page-hero">
        <div className="page-hero-content services-hero-content">
          <ScrollReveal>
            <h1>Services tailored to <em>your stage</em> and needs</h1>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <p className="services-hero-description">
              From ongoing fractional leadership to targeted project work, we provide the technology expertise you need, when you need it.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="section-grid">
          <div className="section-label">
            Services
            <span></span>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <ScrollReveal key={service.title} delay={index * 100}>
                <div className="service-card">
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="engagement-section">
        <div className="section-grid">
          <div className="section-label">
            Engagement
            <span></span>
          </div>
          <div className="engagement-content">
            <ScrollReveal>
              <h2>Flexible models for different needs</h2>
            </ScrollReveal>
            <div className="engagement-models">
              {engagementModels.map((model, index) => (
                <ScrollReveal key={model.title} delay={index * 100}>
                  <div className="engagement-model">
                    <h3>{model.title}</h3>
                    <p>{model.description}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="section-grid">
          <div className="section-label">
            Process
            <span></span>
          </div>
          <ScrollReveal className="process-content">
            <h2>How we start</h2>
            <div className="process-steps">
              <div className="process-step">
                <span className="step-number">01</span>
                <h3>Discovery Call</h3>
                <p>A free 30-minute conversation to understand your situation and determine if there's a fit.</p>
              </div>
              <div className="process-step">
                <span className="step-number">02</span>
                <h3>Initial Assessment</h3>
                <p>For larger engagements, we conduct a focused assessment to understand current state and priorities.</p>
              </div>
              <div className="process-step">
                <span className="step-number">03</span>
                <h3>Proposal</h3>
                <p>Clear scope, deliverables, timeline, and investment—no ambiguity about what you're getting.</p>
              </div>
              <div className="process-step">
                <span className="step-number">04</span>
                <h3>Engagement</h3>
                <p>Regular cadence of work, with clear communication and documented outcomes throughout.</p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection />
    </>
  )
}

export default Services
